export default __webpack_public_path__ + "static/media/Rectangle_82.1c191de9.png";